import am4geodata_canadaLow from '@amcharts/amcharts4-geodata/canadaLow';
import am4geodata_usaLow from '@amcharts/amcharts4-geodata/usaLow';
import am4geodata_australiaLow from '@amcharts/amcharts4-geodata/australiaLow';
import am4geodata_austriaLow from '@amcharts/amcharts4-geodata/austriaLow';
import am4geodata_netherlandsLow from '@amcharts/amcharts4-geodata/netherlandsLow';
import am4geodata_switzerlandLow from '@amcharts/amcharts4-geodata/switzerlandLow';
import am4geodata_franceLow from '@amcharts/amcharts4-geodata/franceLow';
import am4geodata_spainLow from '@amcharts/amcharts4-geodata/spainLow';
import am4geodata_southAfricaLow from '@amcharts/amcharts4-geodata/southAfricaLow';
// import am4geodata_somaliaLow from '@amcharts/amcharts4-geodata/somaliaLow';
// import am4geodata_dominicaLow from '@amcharts/amcharts4-geodata/dominicaLow';
// import am4geodata_romaniaLow from '@amcharts/amcharts4-geodata/romaniaLow';
// import am4geodata_vaticanLow from '@amcharts/amcharts4-geodata/vaticanLow';
// import am4geodata_venezuelaLow from '@amcharts/amcharts4-geodata/venezuelaLow';
// import am4geodata_tanzaniaLow from '@amcharts/amcharts4-geodata/tanzaniaLow';
// import am4geodata_syriaLow from '@amcharts/amcharts4-geodata/syriaLow';
// import am4geodata_russiaLow from '@amcharts/amcharts4-geodata/russiaLow';
// import am4geodata_congoDRLow from '@amcharts/amcharts4-geodata/congoDRLow';
// import am4geodata_congoLow from '@amcharts/amcharts4-geodata/congoLow';
// import am4geodata_omanLow from '@amcharts/amcharts4-geodata/omanLow';
// import am4geodata_southKoreaLow from '@amcharts/amcharts4-geodata/southKoreaLow';
// import am4geodata_northKoreaLow from '@amcharts/amcharts4-geodata/northKoreaLow';
// import am4geodata_nigeriaLow from '@amcharts/amcharts4-geodata/nigeriaLow';
// import am4geodata_moldovaLow from '@amcharts/amcharts4-geodata/moldovaLow';
// import am4geodata_maliLow from '@amcharts/amcharts4-geodata/maliLow';
// import am4geodata_guineaLow from '@amcharts/amcharts4-geodata/guineaLow';
// import am4geodata_dominicanRepublicLow from '@amcharts/amcharts4-geodata/dominicanRepublicLow';
// import am4geodata_curacaoLow from '@amcharts/amcharts4-geodata/curacaoLow';
// import am4geodata_bosniaHerzegovinaLow from '@amcharts/amcharts4-geodata/bosniaHerzegovinaLow';
// import am4geodata_bruneiDarussalamLow from '@amcharts/amcharts4-geodata/bruneiDarussalamLow';
// import am4geodata_antiguaBarbudaLow from '@amcharts/amcharts4-geodata/antiguaBarbudaLow';
// import am4geodata_armeniaLow from '@amcharts/amcharts4-geodata/armeniaLow';
// import am4geodata_azerbaijanLow from '@amcharts/amcharts4-geodata/azerbaijanLow';
// import am4geodata_cyprusLow from '@amcharts/amcharts4-geodata/cyprusLow';
// import am4geodata_georgiaLow from '@amcharts/amcharts4-geodata/georgiaLow';
// import am4geodata_kazakhstanLow from '@amcharts/amcharts4-geodata/kazakhstanLow';
// import am4geodata_boliviaLow from '@amcharts/amcharts4-geodata/boliviaLow';
// import am4geodata_turkeyLow from '@amcharts/amcharts4-geodata/turkeyLow';
// import am4geodata_albaniaLow from '@amcharts/amcharts4-geodata/albaniaLow';
// import am4geodata_belarusLow from '@amcharts/amcharts4-geodata/belarusLow';
// import am4geodata_bulgariaLow from '@amcharts/amcharts4-geodata/bulgariaLow';
// import am4geodata_croatiaLow from '@amcharts/amcharts4-geodata/croatiaLow';
// import am4geodata_czechRepublicLow from '@amcharts/amcharts4-geodata/czechRepublicLow';
// import am4geodata_estoniaLow from '@amcharts/amcharts4-geodata/estoniaLow';
// import am4geodata_hungaryLow from '@amcharts/amcharts4-geodata/hungaryLow';
// import am4geodata_latviaLow from '@amcharts/amcharts4-geodata/latviaLow';
// import am4geodata_lithuaniaLow from '@amcharts/amcharts4-geodata/lithuaniaLow';
// import am4geodata_polandLow from '@amcharts/amcharts4-geodata/polandLow';
// import am4geodata_serbiaLow from '@amcharts/amcharts4-geodata/serbiaLow';
// import am4geodata_slovakiaLow from '@amcharts/amcharts4-geodata/slovakiaLow';
// import am4geodata_sloveniaLow from '@amcharts/amcharts4-geodata/sloveniaLow';
// import am4geodata_ukraineLow from '@amcharts/amcharts4-geodata/ukraineLow';
// import am4geodata_andorraLow from '@amcharts/amcharts4-geodata/andorraLow';
// import am4geodata_belgiumLow from '@amcharts/amcharts4-geodata/belgiumLow';
// import am4geodata_faroeIslandsLow from '@amcharts/amcharts4-geodata/faroeIslandsLow';
// import am4geodata_finlandLow from '@amcharts/amcharts4-geodata/finlandLow';
// import am4geodata_germanyLow from '@amcharts/amcharts4-geodata/germanyLow';
// import am4geodata_greeceLow from '@amcharts/amcharts4-geodata/greeceLow';
// import am4geodata_greenlandLow from '@amcharts/amcharts4-geodata/greenlandLow';
// import am4geodata_icelandLow from '@amcharts/amcharts4-geodata/icelandLow';
// import am4geodata_irelandLow from '@amcharts/amcharts4-geodata/irelandLow';
// import am4geodata_italyLow from '@amcharts/amcharts4-geodata/italyLow';
// import am4geodata_liechtensteinLow from '@amcharts/amcharts4-geodata/liechtensteinLow';
// import am4geodata_denmarkLow from '@amcharts/amcharts4-geodata/denmarkLow';
// import am4geodata_maltaLow from '@amcharts/amcharts4-geodata/maltaLow';
// import am4geodata_norwayLow from '@amcharts/amcharts4-geodata/norwayLow';
// import am4geodata_portugalLow from '@amcharts/amcharts4-geodata/portugalLow';
// import am4geodata_sanMarinoLow from '@amcharts/amcharts4-geodata/sanMarinoLow';
// import am4geodata_swedenLow from '@amcharts/amcharts4-geodata/swedenLow';
// import am4geodata_bahrainLow from '@amcharts/amcharts4-geodata/bahrainLow';
// import am4geodata_israelLow from '@amcharts/amcharts4-geodata/israelLow';
// import am4geodata_kyrgyzstanLow from '@amcharts/amcharts4-geodata/kyrgyzstanLow';
// import am4geodata_qatarLow from '@amcharts/amcharts4-geodata/qatarLow';
// import am4geodata_saudiArabiaLow from '@amcharts/amcharts4-geodata/saudiArabiaLow';
// import am4geodata_tajikistanLow from '@amcharts/amcharts4-geodata/tajikistanLow';
// import am4geodata_uzbekistanLow from '@amcharts/amcharts4-geodata/uzbekistanLow';
// import am4geodata_yemenLow from '@amcharts/amcharts4-geodata/yemenLow';
// import am4geodata_argentinaLow from '@amcharts/amcharts4-geodata/argentinaLow';
// import am4geodata_brazilLow from '@amcharts/amcharts4-geodata/brazilLow';
// import am4geodata_chileLow from '@amcharts/amcharts4-geodata/chileLow';
// import am4geodata_colombiaLow from '@amcharts/amcharts4-geodata/colombiaLow';
// import am4geodata_ecuadorLow from '@amcharts/amcharts4-geodata/ecuadorLow';
// import am4geodata_frenchGuianaLow from '@amcharts/amcharts4-geodata/frenchGuianaLow';
// import am4geodata_peruLow from '@amcharts/amcharts4-geodata/peruLow';
// import am4geodata_belizeLow from '@amcharts/amcharts4-geodata/belizeLow';
// import am4geodata_costaRicaLow from '@amcharts/amcharts4-geodata/costaRicaLow';
// import am4geodata_elSalvadorLow from '@amcharts/amcharts4-geodata/elSalvadorLow';
// import am4geodata_hondurasLow from '@amcharts/amcharts4-geodata/hondurasLow';
// import am4geodata_mexicoLow from '@amcharts/amcharts4-geodata/mexicoLow';
// import am4geodata_nicaraguaLow from '@amcharts/amcharts4-geodata/nicaraguaLow';
// import am4geodata_panamaLow from '@amcharts/amcharts4-geodata/panamaLow';
// import am4geodata_anguillaLow from '@amcharts/amcharts4-geodata/anguillaLow';
// import am4geodata_barbadosLow from '@amcharts/amcharts4-geodata/barbadosLow';
// import am4geodata_bermudaLow from '@amcharts/amcharts4-geodata/bermudaLow';
// import am4geodata_arubaLow from '@amcharts/amcharts4-geodata/arubaLow';
// import am4geodata_newZealandLow from '@amcharts/amcharts4-geodata/newZealandLow';
// import am4geodata_fijiEastLow from '@amcharts/amcharts4-geodata/fijiEastLow';
// import am4geodata_fijiWestLow from '@amcharts/amcharts4-geodata/fijiWestLow';
// import am4geodata_solomonIslandsLow from '@amcharts/amcharts4-geodata/solomonIslandsLow';
// import am4geodata_samoaLow from '@amcharts/amcharts4-geodata/samoaLow';
// import am4geodata_indonesiaLow from '@amcharts/amcharts4-geodata/indonesiaLow';
// import am4geodata_philippinesLow from '@amcharts/amcharts4-geodata/philippinesLow';
// import am4geodata_cambodiaLow from '@amcharts/amcharts4-geodata/cambodiaLow';
// import am4geodata_chinaLow from '@amcharts/amcharts4-geodata/chinaLow';
// import am4geodata_hongKongLow from '@amcharts/amcharts4-geodata/hongKongLow';
// import am4geodata_japanLow from '@amcharts/amcharts4-geodata/japanLow';
// import am4geodata_malaysiaLow from '@amcharts/amcharts4-geodata/malaysiaLow';
// import am4geodata_nepalLow from '@amcharts/amcharts4-geodata/nepalLow';
// import am4geodata_singaporeLow from '@amcharts/amcharts4-geodata/singaporeLow';
// import am4geodata_thailandLow from '@amcharts/amcharts4-geodata/thailandLow';
// import am4geodata_vietnamLow from '@amcharts/amcharts4-geodata/vietnamLow';
// import am4geodata_bangladeshLow from '@amcharts/amcharts4-geodata/bangladeshLow';
// import am4geodata_indiaLow from '@amcharts/amcharts4-geodata/indiaLow';
// import am4geodata_pakistanLow from '@amcharts/amcharts4-geodata/pakistanLow';
// import am4geodata_sriLankaLow from '@amcharts/amcharts4-geodata/sriLankaLow';
// import am4geodata_bhutanLow from '@amcharts/amcharts4-geodata/bhutanLow';
// import am4geodata_maldivesLow from '@amcharts/amcharts4-geodata/maldivesLow';
// import am4geodata_mongoliaLow from '@amcharts/amcharts4-geodata/bangladeshLow';
// import am4geodata_angolaLow from '@amcharts/amcharts4-geodata/angolaLow';
// import am4geodata_burundiLow from '@amcharts/amcharts4-geodata/burundiLow';
// import am4geodata_centralAfricanRepublicLow from '@amcharts/amcharts4-geodata/centralAfricanRepublicLow';
// import am4geodata_gabonLow from '@amcharts/amcharts4-geodata/gabonLow';
// import am4geodata_zambiaLow from '@amcharts/amcharts4-geodata/zambiaLow';
// import am4geodata_djiboutiLow from '@amcharts/amcharts4-geodata/djiboutiLow';
// import am4geodata_kenyaLow from '@amcharts/amcharts4-geodata/kenyaLow';
// import am4geodata_seychellesLow from '@amcharts/amcharts4-geodata/seychellesLow';
// import am4geodata_algeriaLow from '@amcharts/amcharts4-geodata/algeriaLow';
// import am4geodata_chadLow from '@amcharts/amcharts4-geodata/chadLow';
// import am4geodata_egyptLow from '@amcharts/amcharts4-geodata/egyptLow';
// import am4geodata_moroccoLow from '@amcharts/amcharts4-geodata/moroccoLow';
// import am4geodata_sudanLow from '@amcharts/amcharts4-geodata/sudanLow';
// import am4geodata_tunisiaLow from '@amcharts/amcharts4-geodata/tunisiaLow';
// import am4geodata_botswanaLow from '@amcharts/amcharts4-geodata/botswanaLow';
// import am4geodata_namibiaLow from '@amcharts/amcharts4-geodata/namibiaLow';
// import am4geodata_zimbabweLow from '@amcharts/amcharts4-geodata/zimbabweLow';
// import am4geodata_beninLow from '@amcharts/amcharts4-geodata/beninLow';
// import am4geodata_burkinaFasoLow from '@amcharts/amcharts4-geodata/burkinaFasoLow';
// import am4geodata_cameroonLow from '@amcharts/amcharts4-geodata/cameroonLow';
// import am4geodata_equatorialGuineaLow from '@amcharts/amcharts4-geodata/equatorialGuineaLow';
// import am4geodata_senegalLow from '@amcharts/amcharts4-geodata/senegalLow';
import { ukCustom } from './ukCustom.model';
import { AlbersUsa, Mercator } from '@amcharts/amcharts4/.internal/charts/map/projections';

/* eslint-disable @typescript-eslint/naming-convention */
export const mapChartAvailableCountryIsoCodes: any = {
    'CA': {
        'name': 'Canada',
        'amchartsGeodata': [am4geodata_canadaLow],
        'mappedInJournodex': true,
        'homeGeoPoint': { 'longitude': -95, 'latitude': 65 },
        'projection': new Mercator(),
        'homeZoomLevel': 1,
        'start': {
            longitude: -145,
            latitude: -45
        },
        'end': {
            longitude: -45,
            latitude: 90
        }
    },
    'US': {
        'name': 'United States',
        'amchartsGeodata': [am4geodata_usaLow],
        'mappedInJournodex': true,
        'homeGeoPoint': { 'longitude': -97, 'latitude': 35 },
        'projection': new AlbersUsa()
    },
    'GB': {
        'name': 'United Kingdom',
        'amchartsGeodata': [ukCustom],
        'mappedInJournodex': true,
        'homeGeoPoint': { 'longitude': -2.681337129719096, 'latitude': 55 },
        'projection': new Mercator(),
        'homeZoomLevel': 2,
        'start': {
            longitude: -6,
            latitude: 40
        },
        'end': {
            longitude: 1,
            latitude: 70
        }
    },
    'AU': {
        'name': 'Australia',
        'amchartsGeodata': [am4geodata_australiaLow],
        'mappedInJournodex': true,
        'homeGeoPoint': { 'longitude': 133.18263479665612, 'latitude': -29.873285052625242},
        'projection': new Mercator(),
        'homeZoomLevel': 2,
        'start': {
            longitude: 110,
            latitude: -70
        },
        'end': {
            longitude: 150,
            latitude: 10
        }
    },
    'AT': {
        'name': 'Austria',
        'amchartsGeodata': [am4geodata_austriaLow],
        'mappedInJournodex': true,
        'homeGeoPoint': { 'longitude': 13.346996462715108, 'latitude': 47.5},
        'projection': new Mercator(),
        'homeZoomLevel': 3,
        'start': {
            longitude: 8,
            latitude: 40,
        },
        'end': {
            longitude: 18,
            latitude: 56,
        }
    },
    'NL': {
        'name': 'Netherlands',
        'amchartsGeodata': [am4geodata_netherlandsLow],
        'mappedInJournodex': true,
        'homeGeoPoint': { 'longitude': 5.428722641860912, 'latitude': 51.84679760022437},
        'projection': new Mercator(),
        'homeZoomLevel': 2,
        'start': {
            longitude: 3,
            latitude: 45
        },
        'end': {
            longitude: 7,
            latitude: 56
        }
    },
    'FR': {
        'name': 'France',
        'amchartsGeodata': [am4geodata_franceLow],
        'mappedInJournodex': true,
        'homeGeoPoint': { 'longitude': 2.329299709500353, 'latitude': 45.179811706101844 },
        'projection': new Mercator(),
        'homeZoomLevel': 2,
        'start': {
            longitude: 0,
            latitude: 25
        },
        'end': {
            longitude: 7,
            latitude: 65
        }
    },
    'CH': {
        'name': 'Switzerland',
        'amchartsGeodata': [am4geodata_switzerlandLow],
        'mappedInJournodex': true,
        'homeGeoPoint': { 'longitude': 8.202378489483747, 'latitude': 46.5 },
        'projection': new Mercator(),
        'homeZoomLevel': 3,
        'start': {
            longitude: 5,
            latitude: 40,
        },
        'end': {
            longitude: 12,
            latitude: 51,
        },
    },
    'NE': {
        'name': 'Niger',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'SO': {
        'name': 'Somalia',
        // 'amchartsGeodata': [am4geodata_somaliaLow],
        'mappedInJournodex': false
    },
    'PG': {
        'name': 'Papua New Guinea',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'DM': {
        'name': 'Dominica',
        // 'amchartsGeodata': [am4geodata_dominicaLow],
        'mappedInJournodex': false
    },
    'RO': {
        'name': 'Romania',
        // 'amchartsGeodata': [am4geodata_romaniaLow],
        'mappedInJournodex': false
    },
    'VA': {
        'name': 'Vatican City',
        // 'amchartsGeodata': [am4geodata_vaticanLow],
        'mappedInJournodex': false
    },
    'VE': {
        'name': 'Venezuela',
        // 'amchartsGeodata': [am4geodata_venezuelaLow],
        'mappedInJournodex': false
    },
    'TC': {
        'name': 'Turks & Caicos Islands',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'TT': {
        'name': 'Trinidad & Tobago',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'TZ': {
        'name': 'Tanzania',
        // 'amchartsGeodata': [am4geodata_tanzaniaLow],
        'mappedInJournodex': false
    },
    'TW': {
        'name': 'Taiwan',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'ST': {
        'name': 'São Tomé & Principe',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'SY': {
        'name': 'Syria',
        // 'amchartsGeodata': [am4geodata_syriaLow],
        'mappedInJournodex': false
    },
    'VC': {
        'name': 'St Vincent & Grenadines',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'SX': {
        'name': 'St Maarten',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'LC': {
        'name': 'St Lucia',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'KN': {
        'name': 'St Kitts & Nevis',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'SH': {
        'name': 'St Helena',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'BL': {
        'name': 'St Barthelemy',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'RU': {
        'name': 'Russia',
        // 'amchartsGeodata': [am4geodata_russiaLow],
        'mappedInJournodex': false
    },
    'CD': {
        'name': 'Democratic Republic of Congo',
        // 'amchartsGeodata': [am4geodata_congoDRLow],
        'mappedInJournodex': false
    },
    'CG': {
        'name': 'Republic of Congo',
        // 'amchartsGeodata': [am4geodata_congoLow],
        'mappedInJournodex': false
    },
    'PS' : {
        'name': 'Palestinian Authority',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'OM': {
        'name': 'Oman',
        // 'amchartsGeodata': [am4geodata_omanLow],
        'mappedInJournodex': false
    },
    'MK': {
        'name': 'North Macedonia',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'KR': {
        'name': 'South Korea',
        // 'amchartsGeodata': [am4geodata_southKoreaLow],
        'mappedInJournodex': false
    },
    'KP': {
        'name': 'North Korea',
        // 'amchartsGeodata': [am4geodata_northKoreaLow],
        'mappedInJournodex': false
    },
    'NG': {
        'name': 'Nigeria',
        // 'amchartsGeodata': [am4geodata_nigeriaLow],
        'mappedInJournodex': false
    },
    'MD': {
        'name': 'Moldova',
        // 'amchartsGeodata': [am4geodata_moldovaLow],
        'mappedInJournodex': false
    },
    'ML': {
        'name': 'Mali',
        // 'amchartsGeodata': [am4geodata_maliLow],
        'mappedInJournodex': false
    },
    'LA': {
        'name': 'Laos',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'IR': {
        'name': 'Iran',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'GW': {
        'name': 'Guinea Bissau',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'GN': {
        'name': 'Guinea',
        // 'amchartsGeodata': [am4geodata_guineaLow],
        'mappedInJournodex': false
    },
    'FM': {
        'name': 'Federated States of Micronesia',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'FK': {
        'name': 'Falkland Islands',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'DO': {
        'name': 'Dominican Republic',
        // 'amchartsGeodata': [am4geodata_dominicanRepublicLow],
        'mappedInJournodex': false
    },
    'CW' : {
        'name': 'Curaçao',
        // 'amchartsGeodata': [am4geodata_curacaoLow],
        'mappedInJournodex': false
    },
    'CC': {
        'name': 'Cocos Islands',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'BO': {
        'name': 'Bolivia',
        // 'amchartsGeodata': [am4geodata_boliviaLow],
        'mappedInJournodex': false
    },
    'BA': {
        'name': 'Bosnia & Herzegovina',
        // 'amchartsGeodata': [am4geodata_bosniaHerzegovinaLow],
        'mappedInJournodex': false
    },
    'VG': {
        'name': 'British Virgin Islands',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'BN': {
        'name': 'Brunei',
        // 'amchartsGeodata': [am4geodata_bruneiDarussalamLow],
        'mappedInJournodex': false
    },
    'AG': {
        'name': 'Antigua',
        // 'amchartsGeodata': [am4geodata_antiguaBarbudaLow],
        'mappedInJournodex': false
    },
    'AM': {
        'name': 'Armenia',
        // 'amchartsGeodata': [am4geodata_armeniaLow],
        'mappedInJournodex': false
    },
    'AZ': {
        'name': 'Azerbaijan',
        // 'amchartsGeodata': [am4geodata_azerbaijanLow],
        'mappedInJournodex': false
    },
    'CY': {
        'name': 'Cyprus',
        // 'amchartsGeodata': [am4geodata_cyprusLow],
        'mappedInJournodex': false
    },
    'GE': {
        'name': 'Georgia',
        // 'amchartsGeodata': [am4geodata_georgiaLow],
        'mappedInJournodex': false
    },
    'KZ': {
        'name': 'Kazakhstan',
        // 'amchartsGeodata': [am4geodata_kazakhstanLow],
        'mappedInJournodex': false
    },
    'TR': {
        'name': 'Turkey',
        // 'amchartsGeodata': [am4geodata_turkeyLow],
        'mappedInJournodex': false
    },
    'AL': {
        'name': 'Albania',
        // 'amchartsGeodata': [am4geodata_albaniaLow],
        'mappedInJournodex': false
    },
    'BY': {
        'name': 'Belarus',
        // 'amchartsGeodata': [am4geodata_belarusLow],
        'mappedInJournodex': false
    },
    'BG': {
        'name': 'Bulgaria',
        // 'amchartsGeodata': [am4geodata_bulgariaLow],
        'mappedInJournodex': false
    },
    'HR': {
        'name': 'Croatia',
        // 'amchartsGeodata': [am4geodata_croatiaLow],
        'mappedInJournodex': false
    },
    'CZ': {
        'name': 'Czech Republic',
        // 'amchartsGeodata': [am4geodata_czechRepublicLow],
        'mappedInJournodex': false
    },
    'EE': {
        'name': 'Estonia',
        // 'amchartsGeodata': [am4geodata_estoniaLow],
        'mappedInJournodex': false
    },
    'HU': {
        'name': 'Hungary',
        // 'amchartsGeodata': [am4geodata_hungaryLow],
        'mappedInJournodex': false
    },
    'LV': {
        'name': 'Latvia',
        // 'amchartsGeodata': [am4geodata_latviaLow],
        'mappedInJournodex': false
    },
    'LT': {
        'name': 'Lithuania',
        // 'amchartsGeodata': [am4geodata_lithuaniaLow],
        'mappedInJournodex': false
    },
    'PL': {
        'name': 'Poland',
        // 'amchartsGeodata': [am4geodata_polandLow],
        'mappedInJournodex': false
    },
    'RS': {
        'name': 'Serbia',
        // 'amchartsGeodata': [am4geodata_serbiaLow],
        'mappedInJournodex': false
    },
    'SK': {
        'name': 'Slovakia',
        // 'amchartsGeodata': [am4geodata_slovakiaLow],
        'mappedInJournodex': false
    },
    'SI': {
        'name': 'Slovenia',
        // 'amchartsGeodata': [am4geodata_sloveniaLow],
        'mappedInJournodex': false
    },
    'UA': {
        'name': 'Ukraine',
        // 'amchartsGeodata': [am4geodata_ukraineLow],
        'mappedInJournodex': false
    },
    'AD': {
        'name': 'Andorra',
        // 'amchartsGeodata': [am4geodata_andorraLow],
        'mappedInJournodex': false
    },
    'BE': {
        'name': 'Belgium',
        // 'amchartsGeodata': [am4geodata_belgiumLow],
        'mappedInJournodex': false
    },
    'DK': {
        'name': 'Denmark',
        // 'amchartsGeodata': [am4geodata_denmarkLow],
        'mappedInJournodex': false
    },
    'FO': {
        'name': 'Faroe Islands',
        // 'amchartsGeodata': [am4geodata_faroeIslandsLow],
        'mappedInJournodex': false
    },
    'FI': {
        'name': 'Finland',
        // 'amchartsGeodata': [am4geodata_finlandLow],
        'mappedInJournodex': false
    },
    'DE': {
        'name': 'Germany',
        // 'amchartsGeodata': [am4geodata_germanyLow],
        'mappedInJournodex': false
    },
    'GI': {
        'name': 'Gibraltar',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'GR': {
        'name': 'Greece',
        // 'amchartsGeodata': [am4geodata_greeceLow],
        'mappedInJournodex': false
    },
    'GL': {
        'name': 'Greenland',
        // 'amchartsGeodata': [am4geodata_greenlandLow],
        'mappedInJournodex': false
    },
    'IS': {
        'name': 'Iceland',
        // 'amchartsGeodata': [am4geodata_icelandLow],
        'mappedInJournodex': false
    },
    'IE': {
        'name': 'Ireland',
        // 'amchartsGeodata': [am4geodata_irelandLow],
        'mappedInJournodex': false
    },
    'IT': {
        'name': 'Italy',
        // 'amchartsGeodata': [am4geodata_italyLow],
        'mappedInJournodex': false
    },
    'LI': {
        'name': 'Liechtenstein',
        // 'amchartsGeodata': [am4geodata_liechtensteinLow],
        'mappedInJournodex': false
    },
    'LU': {
        'name': 'Luxembourg',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'MT': {
        'name': 'Malta',
        // 'amchartsGeodata': [am4geodata_maltaLow],
        'mappedInJournodex': false
    },
    'MC': {
        'name': 'Monaco',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'NO': {
        'name': 'Norway',
        // 'amchartsGeodata': [am4geodata_norwayLow],
        'mappedInJournodex': false
    },
    'PT': {
        'name': 'Portugal',
        // 'amchartsGeodata': [am4geodata_portugalLow],
        'mappedInJournodex': false
    },
    'SM': {
        'name': 'San Marino',
        // 'amchartsGeodata': [am4geodata_sanMarinoLow],
        'mappedInJournodex': false
    },
    'ES': {
        'name': 'Spain',
        'amchartsGeodata': [am4geodata_spainLow],
        'mappedInJournodex': true,
        'homeGeoPoint': { 'longitude': -3.269093647307221, 'latitude': 39.46869567689394 },
        'projection': new Mercator(),
        'homeZoomLevel': 1,
    },
    'SE': {
        'name': 'Sweden',
        // 'amchartsGeodata': [am4geodata_swedenLow],
        'mappedInJournodex': false
    },
    'ME': {
        'name': 'Montenegro',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'AF': {
        'name': 'Afghanistan',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'BH': {
        'name': 'Bahrain',
        // 'amchartsGeodata': [am4geodata_bahrainLow],
        'mappedInJournodex': false
    },
    'IQ': {
        'name': 'Iraq',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'IL': {
        'name': 'Israel',
        // 'amchartsGeodata': [am4geodata_israelLow],
        'mappedInJournodex': false
    },
    'JO': {
        'name': 'Jordan',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'KW': {
        'name': 'Kuwait',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'KG': {
        'name': 'Kyrgyzstan',
        // 'amchartsGeodata': [am4geodata_kyrgyzstanLow],
        'mappedInJournodex': false
    },
    'LB': {
        'name': 'Lebanon',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'QA': {
        'name': 'Qatar',
        // 'amchartsGeodata': [am4geodata_qatarLow],
        'mappedInJournodex': false
    },
    'SA': {
        'name': 'Saudi Arabia',
        // 'amchartsGeodata': [am4geodata_saudiArabiaLow],
        'mappedInJournodex': false
    },
    'TJ': {
        'name': 'Tajikistan',
        // 'amchartsGeodata': [am4geodata_tajikistanLow],
        'mappedInJournodex': false
    },
    'TM': {
        'name': 'Turkmenistan',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'AE': {
        'name': 'United Arab Emirates',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'UZ': {
        'name': 'Uzbekistan',
        // 'amchartsGeodata': [am4geodata_uzbekistanLow],
        'mappedInJournodex': false
    },
    'YE': {
        'name': 'Yemen',
        // 'amchartsGeodata': [am4geodata_yemenLow],
        'mappedInJournodex': false
    },
    'AR': {
        'name': 'Argentina',
        // 'amchartsGeodata': [am4geodata_argentinaLow],
        'mappedInJournodex': false
    },
    'BR': {
        'name': 'Brazil',
        // 'amchartsGeodata': [am4geodata_brazilLow],
        'mappedInJournodex': false
    },
    'CL': {
        'name': 'Chile',
        // 'amchartsGeodata': [am4geodata_chileLow],
        'mappedInJournodex': false
    },
    'CO': {
        'name': 'Colombia',
        // 'amchartsGeodata': [am4geodata_colombiaLow],
        'mappedInJournodex': false
    },
    'EC': {
        'name': 'Ecuador',
        // 'amchartsGeodata': [am4geodata_ecuadorLow],
        'mappedInJournodex': false
    },
    'GF': {
        'name': 'French Guiana',
        // 'amchartsGeodata': [am4geodata_frenchGuianaLow],
        'mappedInJournodex': false
    },
    'GY': {
        'name': 'Guyana',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'PY': {
        'name': 'Paraguay',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'PE': {
        'name': 'Peru',
        // 'amchartsGeodata': [am4geodata_peruLow],
        'mappedInJournodex': false
    },
    'Code': {
        'name': 'Suriname',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'UY': {
        'name': 'Uruguay',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'BZ': {
        'name': 'Belize',
        // 'amchartsGeodata': [am4geodata_belizeLow],
        'mappedInJournodex': false
    },
    'CR': {
        'name': 'Costa Rica',
        // 'amchartsGeodata': [am4geodata_costaRicaLow],
        'mappedInJournodex': false
    },
    'CU': {
        'name': 'Cuba',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'SV': {
        'name': 'El Salvador',
        // 'amchartsGeodata': [am4geodata_elSalvadorLow],
        'mappedInJournodex': false
    },
    'GT': {
        'name': 'Guatemala',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'HN': {
        'name': 'Honduras',
        // 'amchartsGeodata': [am4geodata_hondurasLow],
        'mappedInJournodex': false
    },
    'MX': {
        'name': 'Mexico',
        // 'amchartsGeodata': [am4geodata_mexicoLow],
        'mappedInJournodex': false
    },
    'NI': {
        'name': 'Nicaragua',
        // 'amchartsGeodata': [am4geodata_nicaraguaLow],
        'mappedInJournodex': false
    },
    'PA': {
        'name': 'Panama',
        // 'amchartsGeodata': [am4geodata_panamaLow],
        'mappedInJournodex': false
    },
    'AI': {
        'name': 'Anguilla',
        // 'amchartsGeodata': [am4geodata_anguillaLow],
        'mappedInJournodex': false
    },
    'BS': {
        'name': 'Bahamas',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'BB': {
        'name': 'Barbados',
        // 'amchartsGeodata': [am4geodata_barbadosLow],
        'mappedInJournodex': false
    },
    'BM': {
        'name': 'Bermuda',
        // 'amchartsGeodata': [am4geodata_bermudaLow],
        'mappedInJournodex': false
    },
    'KY': {
        'name': 'Cayman Islands',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'GD': {
        'name': 'Grenada',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'GP': {
        'name': 'Guadeloupe',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'HT': {
        'name': 'Haiti',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'JM': {
        'name': 'Jamaica',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'MQ': {
        'name': 'Martinique',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'MS': {
        'name': 'Montserrat',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'AW': {
        'name': 'Aruba',
        // 'amchartsGeodata': [am4geodata_arubaLow],
        'mappedInJournodex': false
    },
    'NZ': {
        'name': 'New Zealand',
        // 'amchartsGeodata': [am4geodata_newZealandLow],
        'mappedInJournodex': false
    },
    'FJ': {
        'name': 'Fiji',
        // 'amchartsGeodata': [am4geodata_fijiEastLow, am4geodata_fijiWestLow],
        'mappedInJournodex': false
    },
    'PF': {
        'name': 'French Polynesia',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'KI': {
        'name': 'Kiribati',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'MH': {
        'name': 'Marshall Islands',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'NR': {
        'name': 'Nauru',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'NC': {
        'name': 'New Caledonia',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'NF': {
        'name': 'Norfolk Island',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'PN': {
        'name': 'Pitcairn Islands',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'SB': {
        'name': 'Solomon Islands',
        // 'amchartsGeodata': [am4geodata_solomonIslandsLow],
        'mappedInJournodex': false
    },
    'TO': {
        'name': 'Tonga',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'TV': {
        'name': 'Tuvalu',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'VU': {
        'name': 'Vanuatu',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'WS': {
        'name': 'Samoa',
        // 'amchartsGeodata': [am4geodata_samoaLow],
        'mappedInJournodex': false
    },
    'CK': {
        'name': 'Cook Islands',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'CX': {
        'name': 'Christmas Island',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'PW': {
        'name': 'Palau',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'GU': {
        'name': 'Guam',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'ID': {
        'name': 'Indonesia',
        // 'amchartsGeodata': [am4geodata_indonesiaLow],
        'mappedInJournodex': false
    },
    'PH': {
        'name': 'Philippines',
        // 'amchartsGeodata': [am4geodata_philippinesLow],
        'mappedInJournodex': false
    },
    'KH': {
        'name': 'Cambodia',
        // 'amchartsGeodata': [am4geodata_cambodiaLow],
        'mappedInJournodex': false
    },
    'CN': {
        'name': 'China',
        // 'amchartsGeodata': [am4geodata_chinaLow],
        'mappedInJournodex': false
    },
    'HK': {
        'name': 'Hong Kong',
        // 'amchartsGeodata': [am4geodata_hongKongLow],
        'mappedInJournodex': false
    },
    'JP': {
        'name': 'Japan',
        // 'amchartsGeodata': [am4geodata_japanLow],
        'mappedInJournodex': false
    },
    'MY': {
        'name': 'Malaysia',
        // 'amchartsGeodata': [am4geodata_malaysiaLow],
        'mappedInJournodex': false
    },
    'NP': {
        'name': 'Nepal',
        // 'amchartsGeodata': [am4geodata_nepalLow],
        'mappedInJournodex': false
    },
    'SG': {
        'name': 'Singapore',
        // 'amchartsGeodata': [am4geodata_singaporeLow],
        'mappedInJournodex': false
    },
    'TH': {
        'name': 'Thailand',
        // 'amchartsGeodata': [am4geodata_thailandLow],
        'mappedInJournodex': false
    },
    'VN': {
        'name': 'Vietnam',
        // 'amchartsGeodata': [am4geodata_vietnamLow],
        'mappedInJournodex': false
    },
    'BD': {
        'name': 'Bangladesh',
        // 'amchartsGeodata': [am4geodata_bangladeshLow],
        'mappedInJournodex': false
    },
    'MM': {
        'name': 'Myanmar',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'IN': {
        'name': 'India',
        // 'amchartsGeodata': [am4geodata_indiaLow],
        'mappedInJournodex': false
    },
    'PK': {
        'name': 'Pakistan',
        // 'amchartsGeodata': [am4geodata_pakistanLow],
        'mappedInJournodex': false
    },
    'LK': {
        'name': 'Sri Lanka',
        // 'amchartsGeodata': [am4geodata_sriLankaLow],
        'mappedInJournodex': false
    },
    'BT': {
        'name': 'Bhutan',
        // 'amchartsGeodata': [am4geodata_bhutanLow],
        'mappedInJournodex': false
    },
    'MV': {
        'name': 'Maldives',
        // 'amchartsGeodata': [am4geodata_maldivesLow],
        'mappedInJournodex': false
    },
    'MN': {
        'name': 'Mongolia',
        // 'amchartsGeodata': [am4geodata_mongoliaLow],
        'mappedInJournodex': false
    },
    'TL': {
        'name': 'Timor-Leste',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'AO': {
        'name': 'Angola',
        // 'amchartsGeodata': [am4geodata_angolaLow],
        'mappedInJournodex': false
    },
    'BI': {
        'name': 'Burundi',
        // 'amchartsGeodata': [am4geodata_burundiLow],
        'mappedInJournodex': false
    },
    'CF': {
        'name': 'Central African Republic',
        // 'amchartsGeodata': [am4geodata_centralAfricanRepublicLow],
        'mappedInJournodex': false
    },
    'GA': {
        'name': 'Gabon',
        // 'amchartsGeodata': [am4geodata_gabonLow],
        'mappedInJournodex': false
    },
    'RW': {
        'name': 'Rwanda',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'ZM': {
        'name': 'Zambia',
        // 'amchartsGeodata': [am4geodata_zambiaLow],
        'mappedInJournodex': false
    },
    'KM': {
        'name': 'Comoros',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'DJ': {
        'name': 'Djibouti',
        // 'amchartsGeodata': [am4geodata_djiboutiLow],
        'mappedInJournodex': false
    },
    'KE': {
        'name': 'Kenya',
        // 'amchartsGeodata': [am4geodata_kenyaLow],
        'mappedInJournodex': false
    },
    'MW': {
        'name': 'Malawi',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'MU': {
        'name': 'Mauritius',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'MZ': {
        'name': 'Mozambique',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'SC': {
        'name': 'Seychelles',
        // 'amchartsGeodata': [am4geodata_seychellesLow],
        'mappedInJournodex': false
    },
    'UG': {
        'name': 'Uganda',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'DZ': {
        'name': 'Algeria',
        // 'amchartsGeodata': [am4geodata_algeriaLow],
        'mappedInJournodex': false
    },
    'TD': {
        'name': 'Chad',
        // 'amchartsGeodata': [am4geodata_chadLow],
        'mappedInJournodex': false
    },
    'EG': {
        'name': 'Egypt',
        // 'amchartsGeodata': [am4geodata_egyptLow],
        'mappedInJournodex': false
    },
    'ER': {
        'name': 'Eritrea',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'ET': {
        'name': 'Ethiopia',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'LY': {
        'name': 'Libya',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'MR': {
        'name': 'Mauritania',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'MA': {
        'name': 'Morocco',
        // 'amchartsGeodata': [am4geodata_moroccoLow],
        'mappedInJournodex': false
    },
    'SD': {
        'name': 'Republic of Sudan',
        // 'amchartsGeodata': [am4geodata_sudanLow],
        'mappedInJournodex': false
    },
    'TN': {
        'name': 'Tunisia',
        // 'amchartsGeodata': [am4geodata_tunisiaLow],
        'mappedInJournodex': false
    },
    'BW': {
        'name': 'Botswana',
        // 'amchartsGeodata': [am4geodata_botswanaLow],
        'mappedInJournodex': false
    },
    'LS': {
        'name': 'Lesotho',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'MG': {
        'name': 'Madagascar',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'NA': {
        'name': 'Namibia',
        // 'amchartsGeodata': [am4geodata_namibiaLow],
        'mappedInJournodex': false
    },
    'ZA': {
        'name': 'South Africa',
        'mappedInJournodex': true,
        'amchartsGeodata': [am4geodata_southAfricaLow],
        'homeGeoPoint': { 'longitude': 24.349261439249204, 'latitude': -30.909990570179115 },
        'projection': new Mercator(),
        'homeZoomLevel': 1,
    },
    'SZ': {
        'name': 'Swaziland',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'ZW': {
        'name': 'Zimbabwe',
        // 'amchartsGeodata': [am4geodata_zimbabweLow],
        'mappedInJournodex': false
    },
    'BJ': {
        'name': 'Benin',
        // 'amchartsGeodata': [am4geodata_beninLow],
        'mappedInJournodex': false
    },
    'BF': {
        'name': 'Burkina Faso',
        // 'amchartsGeodata': [am4geodata_burkinaFasoLow],
        'mappedInJournodex': false
    },
    'CM': {
        'name': 'Cameroon',
        // 'amchartsGeodata': [am4geodata_cameroonLow],
        'mappedInJournodex': false
    },
    'CV': {
        'name': 'Cape Verde Islands',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'GQ': {
        'name': 'Equatorial Guinea',
        // 'amchartsGeodata': [am4geodata_equatorialGuineaLow],
        'mappedInJournodex': false
    },
    'GM': {
        'name': 'Gambia',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'GH': {
        'name': 'Ghana',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'LR': {
        'name': 'Liberia',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'SN': {
        'name': 'Senegal',
        // 'amchartsGeodata': [am4geodata_senegalLow],
        'mappedInJournodex': false
    },
    'SL': {
        'name': 'Sierra Leone',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'TG': {
        'name': 'Togo',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'SS': {
        'name': 'South Sudan',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    },
    'YT': {
        'name': 'Mayotte',
        // 'amchartsGeodata': [],
        'mappedInJournodex': false
    }
};
